import { defineObstacle } from '../schema';

/* ═══════════════════════════════════════════════════════════════════════════
   MASTODONTE — le gros astéroïde destructible qui éclate en PLEINS de morceaux.

   Le plus gros rocher qu'on puisse casser (r 68), juste sous l'indestructible
   Colosse (r 82). Sa raison d'être n'est pas ses 360 PV mais son BRISEMENT :
   au-dessus du seuil de fragmentation, un obstacle détruit ne disparaît pas, il
   se brise en sous-morceaux de tailles différentes qui s'écartent de l'impact
   (voir `shatterObstacle`). À cette taille, il en lâche six — un vrai champ de
   débris là où il n'y avait qu'un bloc.

   C'est donc un choix à double tranchant, exactement ce qu'un obstacle
   destructible doit produire : le faire sauter immobilise le tir plus d'une
   seconde ET remplit l'écran de fragments à esquiver dans la foulée. Le
   contourner coûte du terrain mais garde l'écran propre. Les deux sont des jeux
   valides.

   `radius: 68` : sa dureté doit se LIRE à sa seule silhouette — un joueur juge
   « celui-là, je ne le casse pas au milieu d'une nuée » avant le premier tir.
   ═══════════════════════════════════════════════════════════════════════════ */

export default defineObstacle({
  id: 'astero-mastodonte',
  radius: 68,
  hp: 360,
  destructible: true,
  score: 130,
});
